export default [
  'name',
  'description',
  'weight',
  'price',
  'points',
  'minCount',
  'maxCount',
  'stoplight',
  'tags'
];
